export function singleFlight<TArguments extends unknown[]>(
  task: (...arguments_: TArguments) => Promise<void>,
) {
  let inFlight = false;
  return async (...arguments_: TArguments) => {
    if (inFlight) return;
    inFlight = true;
    try {
      await task(...arguments_);
    } finally {
      inFlight = false;
    }
  };
}